<template>
    <div class="p-4 bg-white rounded-[19px] shadow flex-col justify-start items-start gap-3 inline-flex sm:p-6">
        <div>
            <div class="text-slate-700 text-xl font-extrabold">Events</div>
            <div class="text-slate-400 text-sm font-normal">Data ingested in Voxie</div>
        </div>

        <div v-if="events.length > 0" class="flex flex-col gap-4 w-full">
            <integration-log-event-item v-for="(event, index) in events" :key="index" :event="event" />
        </div>
        <div v-else class="text-sm text-slate-500">No events recorded.</div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import IntegrationLogEventItem from './IntegrationLogEventItem.vue';
import type { IntegrationLogEntry } from '~/services/integrationLogsClient';

interface IntegrationLogEvent {
    type: string;
    data: Record<string, unknown>;
}

const props = defineProps<{
    entry: IntegrationLogEntry;
}>();

const events = computed<IntegrationLogEvent[]>(() => {
    if (!Array.isArray(props.entry.events)) {
        return [];
    }
    return props.entry.events as IntegrationLogEvent[];
});
</script>
